jQuery(document).ready(function($) {
    if($('body').hasClass('write_message')) {
        deleteCookie('message_sent');
        $('form').submit(function() {
            setCookie('message_sent',true);
        });
    }
});